import React, { useRef, useEffect, useState } from "react";
import Images from "../images";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SignIn from "./SignIn";
import LazyImg from "./LazyImg";
import { Link } from "react-router-dom";
import axiosInstance from "../Help/AxiosLogicInstance";
import "./ApplicationBanner.css";

const ObservershipProgram = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formSource, setFormSource] = useState("");
  const { setActiveModal } = useOutletContext();
  const token = localStorage.getItem("token");
  const [isFormActive, setIsFormActive] = useState(false);
  const [certificateData, setCertificateData] = useState({
    recipientName: "Dr. Minal Desale",
    program: "MedEngage Observership",
    institution: "Metropolis Healthcare Ltd.",
    location: "Global Reference Laboratory, Vikhroli, Mumbai",
    date: "24th Aug 2022",
    authority: "Dr. Kirti Chadha",
    title: "Chief Scientific Officer",
  });
  const [loading, setLoading] = useState(true);
  
  // Check if the form is active
  useEffect(() => {
    const checkFormStatus = async () => {
      try {
        const response = await axiosInstance.get('/api/Student/GetApplicationSettingMasterByFormId/4');
        if (response.data && 
            response.data.Status === "200" && 
            response.data.Data && 
            response.data.Data.length > 0) {
          setIsFormActive(response.data.Data[0].IsActive);
        } else {
          setIsFormActive(false);
        }
      } catch (error) {
        console.error("Error fetching form status:", error);
        setIsFormActive(false);
      }
    };
    
    checkFormStatus();
  }, []);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);

  const [showSignIn, setShowSignIn] = useState(false);
  const faqs = [
    {
      question: "Do we have a choice of place in the observership program ?",
      answer: "Yes.",
    },
    {
      question: "How can one access to observership of Metropolis laboratory ?",
      answer:
        "The students keen to have observership will have to register online.",
    },
    {
      question: "How many days will be observership ?",
      answer: "The time for observership ranges from 5-15 days.",
    },
    {
      question: "Have old categories been dissolved ?",
      answer: "No",
    },
    {
      question:
        "Will participants get certificates at the end of their observership ?",
      answer:
        "Yes, after successfully completing observership and submitting feedback, participants will get a  certificate.",
    },
    {
      question: "How many observerships have been completed to date?",
      answer: "359 observerships conducted so far, and the count continues.",
    },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    document.title = "Observership Program - MedEngage";
  }, []);

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Observership Program</h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                 <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>Observership Program</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                    MedEngage{" "}
                    <span>
                      <strong className="green"> Observership Program</strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                    MedEngage Observership Program Students all across India can
                    avail of exclusive MedEngage Observership programs at over
                    200 Metropolis Laboratories across India. During their
                    program, they will have access to a world-class laboratory
                    ecosystem and access to a panel of doctors.
                  </p>
                  <ul className="observership-list">
                    <li>
                      <i className="fa fa-check-circle tick-icon"></i>
                      The Observership Programme is for Graduate, Post Graduate,
                      MD / MBBS and Medical Students and others. The
                      students/doctor must be registered under the program
                      online.
                    </li>

                    <li>
                      <i className="fa fa-check-circle tick-icon"></i>
                      The Observership Programme will be a no-profit-no-loss
                      proposition.
                    </li>

                    <li>
                      <i className="fa fa-check-circle tick-icon"></i>
                      Students will learn with selected Department Lab Managers.
                    </li>

                    <li>
                      <i className="fa fa-check-circle tick-icon"></i>
                      Students will submit feedback about their experience and a
                      learning experience certificate will be released.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper text-center">
                    <LazyImg
                      src={Images.Observership}
                      alt="Observership program at Global Reference Laboratory, Vikhroli"
                      className="scholarship-image rounded-3"
                    />
                    <div className="img-caption mt-2">
                      Observership conducted at GRL (Global Reference Laboratory
                      for MBBS students) at Vidhyavihar.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="stats-section">
          <div className="container">
            <h2 className="ul-section-title text-white text-center mb-4">
              Observership Details
            </h2>
            <div className="stats-grid d-flex justify-content-center flex-wrap gap-4">
              <div className="stat-card">
                <div className="stat-number">200</div>
                <div className="stat-label">
                  Laboratories
                  <br />
                  <span className="text-dark">
                    200 Metropolis laboratories all over India
                  </span>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-number">5-15</div>
                <div className="stat-label">
                  Working Days
                  <br />
                  <span className="text-dark">
                    Duration of 5-15 working days as per the course
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-about ul-section-spacing">
          <div className="container">
            <h2 className="text-center mb-5 fw-bold">
              Student <span className="text-success">Experience</span>
            </h2>

            <div className="position-relative text-white p-4 p-md-5 student-experience bg-gradient-to-br">
              {/* Decorative circles */}
              <div className="decor-circle top-right"></div>
              <div className="decor-circle bottom-left"></div>

              <div className="position-relative z-1">
                {/* User Info */}
                <div className="d-flex align-items-center mb-3">
                  <div className="d-flex justify-content-center align-items-center rounded-3 me-3 user-icon">
                    <i className="fa fa-user fa-lg text-white fs-2"></i>
                  </div>
                  <div>
                    <h3 className="mb-0">Kasturi Date</h3>
                    <p className="text-light mb-0">MedEngage Observer</p>
                  </div>
                </div>

                {/* Quote */}
                <blockquote className="fst-italic mb-3 quote-block">
                  "Metropolis Healthcare Ltd.'s excellence is well-known
                  throughout India. I'm really grateful to Metropolis and K. C.
                  College for giving an opportunity to opt there for an
                  Observership. In the period of two weeks I almost covered the
                  Microbiology and Molecular Biology department. All the staff
                  over there is good. They all were very helpful and encouraging
                  throughout an observership. They showed every technique with
                  the same enthusiasm, so I really loved working there for 15
                  days. Got to know so many new things which I was unaware of.
                  It was overall a great experience to spend time there."
                </blockquote>

                {/* Duration & Department */}
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge bgg-light text-dark fs-6">
                    Duration: 15 Days
                  </span>
                  <span className="badge bg-white text-dark fs-6">
                    Department: Microbiology
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* TEAM SECTION START */}
        <section className="ul-about ul-section-spacing bgg-light">
          <div className="container">
            {/* Certificate Display */}
            <div className="card text-center p-5 mb-4 position-relative certificate-card">
              {/* Decorative corner accents */}
              <div className="corner top-left"></div>
              <div className="corner top-right"></div>
              <div className="corner bottom-left"></div>
              <div className="corner bottom-right"></div>

              {/* Logo Area */}
              <div className="logo-container d-flex align-items-center gap-2 mb-3">
                <LazyImg
                  src={Images.Logo}
                  alt="MedEngage logo"
                  className="logo-left"
                  loading="eager"
                />
                <LazyImg
                  src={Images.Metropolis}
                  alt="Metropolis Healthcare logo"
                  className="logo-right"
                  loading="eager"
                />
              </div>

              {/* Certificate Title */}
              <h2 className="text-success mb-3">Certificate of Achievement</h2>
              <hr className="w-25 mx-auto border-warning" />

              {/* Main Content */}
              <p>This is to certify that</p>
              <h3 className="mb-3">{certificateData.recipientName}</h3>
              <p>
                has successfully completed the{" "}
                <strong>{certificateData.program}</strong> program under the{" "}
                {certificateData.institution}
              </p>
              <p>{certificateData.location}</p>

              {/* Date & Signature */}
              <div className="row mt-5">
                <div className="col text-start">
                  <p className="mb-1">Date:</p>
                  <strong>{certificateData.date}</strong>
                </div>
                <div className="col text-end">
                  <div className="border-bottom mx-auto"></div>
                  <strong>{certificateData.authority}</strong>
                  <div>{certificateData.title}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-about ul-section-spacing">
          <div className="ul-container application-banner">
            <div className="row align-items-center">
              {/* Left Illustration */}
              <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
                <LazyImg
                  src={Images.Observershipvector}
                  alt="Observership illustration"
                  className="img-fluid"
                />
              </div>

              {/* Right Text */}
              <div className="col-md-6 text-center text-md-start">
                <h2 className="mb-2 text-light fw-bold">
                  Observership Application
                </h2>
                <p className="mb-3 text-light">
                  Apply now and take your first step to success.
                </p>

                <div className="d-flex flex-column flex-sm-row align-items-center gap-2 justify-content-center justify-content-md-start">
                  {isFormActive ? (
                    token ? (
                      <button
                        className="btn-login btn-lg"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/observership-application/");
                        }}
                      >
                        Apply
                      </button>
                    ) : (
                      <button
                        className="btn-login d-flex align-items-center gap-2"
                        onClick={() => {
                          if (token) navigate("/observership-application/");
                          else setActiveModal("signIn"); // opens SignIn modal
                        }}
                      >
                        Login
                      </button>
                    )
                  ) : (
                    <div className="alert alert-info mb-0">
                      Applications are currently closed. Please check back later.
                    </div>
                  )}

                  {showSignIn && (
                    <SignIn
                      show={showSignIn}
                      handleClose={() => setShowSignIn(false)}
                      from={formSource}
                    />
                  )}
                  <LazyImg
                    src={Images.Arrow}
                    alt="decorative arrow"
                    className="img-fluid ms-5 arrow-image   d-none d-lg-inline-block"
                    style={{ transform: "rotate(70deg)" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ul-team ul-section-spacing">
          <div className="container">
            {/* Section Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold">
                <span className="text-success">Observership</span> Course
                Faculty
              </h2>
            </div>

            {/* Team Members */}
            <div className="row justify-content-center">
              {/* Member 1 */}
              <div className="col-lg-3 col-md-6 col-sm-8 col-10 mb-4 d-flex justify-content-center">
                <div className="position-relative bg-light rounded-5 shadow-sm p-3 card-container-sm text-center h-100 d-flex flex-column">
                  <div className="mb-3">
                    <div className="p-1 mb-3 d-inline-block profile-ring-rect">
                      <LazyImg
                        src={Images.Kirti}
                        alt="Dr. Kirti Chadha - profile"
                        className="profile-img-rect"
                      />
                    </div>
                  </div>
                  <h2 className="h5 fw-bold mb-1">Dr. Kirti Chadha</h2>
                  <p className="text-success fw-medium mb-2">Course Director</p>
                </div>
              </div>

              {/* Member 2 */}
              <div className="col-lg-3 col-md-6 col-sm-8 col-10 mb-4 d-flex justify-content-center">
                <div className="position-relative bg-light rounded-5 shadow-sm p-3 card-container-sm text-center h-100 d-flex flex-column">
                  <div className="mb-3">
                    <div className="p-1 mb-3 d-inline-block profile-ring-rect">
                      <LazyImg
                        src={Images.Rakhi}
                        alt="Dr. Rakhi Bajpai - profile"
                        className="profile-img-rect rounded-2"
                      />
                    </div>
                  </div>
                  <h2 className="h5 fw-bold mb-1">Dr. Rakhi Bajpai</h2>
                  <p className="text-success fw-medium mb-2">
                    Course Moderator
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-8 col-10 mb-4 d-flex justify-content-center">
                <div className="position-relative bg-light rounded-5 shadow-sm p-3 card-container-sm text-center h-100 d-flex flex-column">
                  <div className="mb-3">
                    <div className="p-1 mb-3 d-inline-block profile-ring-rect">
                      <LazyImg
                        src={Images.Anitasuryanarayan}
                        alt="Dr. Anita Suryanarayan - profile"
                        className="profile-img-rect"
                      />
                    </div>
                  </div>
                  <h2 className="h5 fw-bold mb-1">Dr.Anita Suryanarayan </h2>
                  <p className="text-success fw-medium mb-2">Course Director</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TEAM SECTION END */}

        <section className="faq-section">
          <div className="ul-container">
            <h2 className="ul-section-title text-center p-2 m-2">FAQs</h2>
            <div className="faq-container">
              <div className="faq-grid">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="faq-item"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div style={{ flex: 1 }}>
                      <span className="faq-question">{faq.question}</span>
                      <div
                        className={`faq-answer ${
                          openIndex === index ? "show" : ""
                        }`}
                        onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
                      >
                        {faq.answer}
                      </div>
                    </div>
                    <span className="faq-icon">
                      <LazyImg
                        src={openIndex === index ? Images.Minus : Images.Plus}
                        alt={openIndex === index ? "Collapse" : "Expand"}
                        className="faq-toggle-icon"
                      />
                    </span>
                  </div>
                ))}
              </div>
              {/*  <div className="text-center mt-4">
            <button className="btn-view">View All</button>
          </div> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ObservershipProgram;
